<template>
    <router-view></router-view>
</template>

<script>

import router from './router/index'
export default {
  name: 'App',
  router:router,
}
</script>

<style>
</style>
